module.exports = __webpack_public_path__ + "static/media/pause.481fd195.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/pause.svg
// module id = 1125
// module chunks = 21